<script lang="ts">
    import {getLogger} from 'src/core';
    import type {FormControlOptions} from '../../forms/types';
    import type {ValueEditorOptions} from '../../../kp-value-editor/types';
    import type {ValueEditorSize} from '../../../types';
    import type {FormControl} from '../../forms/form-control';
    import {FormControlBuilder} from '../../forms/form-control';
    import {formControls} from '../../forms/use.form-controls';
    import {onDestroy} from 'svelte';
    import {ignoreUnusedProperties} from 'shared/utils/custom-utils';

    type MODEL_VALUE = $$Generic;

    export let model: MODEL_VALUE;
    export let formControlOptions: FormControlOptions;
    export let editorId: string;
    export let editorName: string;

    export let placeholder: string;
    export let isDisabled: boolean;
    export let isFocused: boolean;
    export let forceShowErrors: boolean;
    export let size: ValueEditorSize;

    export let options: ValueEditorOptions;
    export let validations: never;

    ignoreUnusedProperties(placeholder, isFocused, forceShowErrors, size, options, validations);

    const formControl = FormControlBuilder.for(editorId, editorName, model)
        .withOptions(formControlOptions)
        .build(getLogger());

    const subscription = formControl.getModelValue$().subscribe((value) => model = value);  // two-way data binding -> sending updated value up to a parent
    $: formControl.setModelValue(model); // two-way data binding -> receiving new model value from parent

    onDestroy(() => {
        subscription.unsubscribe();
    });

    export function getFormController(): FormControl<MODEL_VALUE> {
        return formControl;
    }
</script>

<input id={editorId}
       name={editorName}
       type="hidden"
       disabled={isDisabled}
       use:formControls={formControl}
       data-main-input/>